import React from 'react'
import { get } from 'lodash'
import RequirementLabel from '../../requirements/label'
import RequirementIcon from '../../requirements/icon'
import { Row, Col } from 'react-bootstrap'
import GradeLevelRequirement from './grade-level-requirement'

const DetailsCardRequirements = ({
    experience = {}
}) => {

    const courseRequirements = get(experience, 'requirements', [])

    const renderRequirement = (courseRequirement) => {
        return (
            <div key={courseRequirement.id} style={{ padding: '15px'}}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <RequirementIcon courseRequirement={courseRequirement} />
                    <strong style={{ paddingLeft: '10px'}}><RequirementLabel courseRequirement={courseRequirement} /></strong>
                </div>
                
            </div>
        )
    }

    return (
        <div style={{
            display: 'flex',
            flexWrap: 'wrap',
        }}>
            <GradeLevelRequirement experience={experience} />
            {courseRequirements.map(renderRequirement)}
        </div>
    )
}

export default DetailsCardRequirements